// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredients__BreadBottom__gsMqg","BreadTop":"BurgerIngredients__BreadTop__cf5cI","Seeds1":"BurgerIngredients__Seeds1__3kZp-","Seeds2":"BurgerIngredients__Seeds2__n1snp","Meat":"BurgerIngredients__Meat__3m-0W","Cheese":"BurgerIngredients__Cheese__eez_s","Salad":"BurgerIngredients__Salad__38exq","Bacon":"BurgerIngredients__Bacon__3-YnJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredients.css
// module id = 138
// module chunks = 3